import React__default, { forwardRef, useRef } from 'react';
import * as Switch$1 from '@radix-ui/react-switch';
import { useRefObjectAsForwardedRef } from '../../hooks/useRefObjectAsForwardedRef.js';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 *  Contains all the parts of a switch. An `input` will also render when used within a form to ensure events propagate correctly.
 *
 * [data-state]: "checked" | "unchecked"
 * [data-disabled]: Present when disabled
 *
 */
const Root = /*#__PURE__*/forwardRef(({
  ...props
}, forwardedRef) => {
  const innerRef = useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  return /*#__PURE__*/React__default.createElement(Switch$1.Root, _extends({
    ref: innerRef
  }, props));
});

/**
 *  The thumb that is used to visually indicate whether the switch is on or off.
 *
 * [data-state]: "checked" | "unchecked"
 * [data-disabled]: Present when disabled
 *
 */
const Thumb = /*#__PURE__*/forwardRef(({
  ...props
}, forwardedRef) => {
  const innerRef = useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  return /*#__PURE__*/React__default.createElement(Switch$1.Thumb, _extends({
    ref: innerRef
  }, props));
});
Thumb.displayName = 'Thumb';
Root.displayName = 'Switch';
var Switch = Object.assign(Root, {
  Thumb
});

export { Switch as default };
